import { defineTranslations } from "../typeHelpers/defineTranslations"
import type { TranslationRecord } from "../types/translationTypes"
import type { en } from "./en"

export const nl = defineTranslations<TranslationRecord<typeof en>>()({
  "actions": "Acties",
  "add": "Toevoegen",
  "age": "Leeftijd",
  "age.month": "m",
  "age.year": "j",
  "apply": "Toepassen",
  "birthday": "Verjaardag",
  "boolean.false": "Nee",
  "boolean.true": "Ja",
  "born": "Geboren",
  "cancel": "Sluiten",
  "close": "Sluiten",
  "collapsedText.hide": "Verbergen",
  "collapsedText.show": "Meer tonen",
  "confirm": "Bevestigen",
  "confirmClose.accept": "Annuleren",
  "confirmClose.body": "Als je je invoer annuleert, worden je wijzigingen niet opgeslagen.",
  "confirmClose.title": "Wijzigingen annuleren?",
  "count.items": "{count} items",
  "create": "Creëren",
  "danish": "Deens",
  "dateRangeFilterForm.fromDate": "Van datum",
  "dateRangeFilterForm.toDate": "Tot datum",
  "delete": "Verwijderen",
  "details": "Details",
  "dutch": "Nederlands",
  "edit": "Bewerken",
  "empty": "Leeg",
  "emptyState.items": "data",
  "emptyState.noItems": "Geen {itemName}",
  "english": "Engels",
  "entries.add": "{entry} toevoegen",
  "entries.add.another": "Nog een {entry} toevoegen",
  "error.400.message": "Ongeldige aanvraag",
  "error.401.message": "Niet geautoriseerd",
  "error.403.message": "Onvoldoende toegang",
  "error.404.message": "Niet gevonden",
  "error.408.message": "Timeout",
  "error.fallback.message": "Er is een foutmelding opgetreden",
  "false": "Nee",
  "filterFormButtons.reset": "Wissen",
  "filterFormButtons.search": "Zoek",
  "finish": "Voltooien",
  "form.showOnlyChanges": "Toon alleen wijzigingen",
  "genericUnavailableAction": "Deze actie is niet beschikbaar vanwege de huidige gegevens/rechten.",
  "input.nothingFound": "Geen resultaten gevonden",
  "input.startToAdd": "Begin met typen om toe te voegen…",
  "input.startTyping": "Begin met typen om te zoeken…",
  "inputWrapper.bigger": "De nieuwe waarde is groter dan de bestaande waarde.",
  "inputWrapper.defaultValueTooltip": "Klik om terug te keren naar de standaardwaarde",
  "inputWrapper.different": "De nieuwe waarde is anders dan de bestaande waarde.",
  "inputWrapper.existingValueTooltip": "Klik om terug te keren naar de bestaande waarde",
  "inputWrapper.smaller": "De nieuwe waarde is kleiner dan de bestaande waarde.",
  "match": "Overeenkomst",
  "months": "{months} maanden",
  "next": "Volgende",
  "no": "Nee",
  "none": "Geen",
  "notFound": "Niet gevonden",
  "option.noDataAvailable": "Geen gegevens beschikbaar",
  "previous": "Vorige",
  "save": "Opslaan",
  "search": "Zoeken",
  "select.noResults": "Geen resultaten gevonden",
  "select.pleaseTypeToSearch": "Begin met typen om te zoeken",
  "signout": "Afmelden",
  "table.filter.maxTitle": "Max",
  "table.filter.minTitle": "Min",
  "table.filter.toggleAll": "Schakel alles in",
  "total": "Totaal",
  "true": "Ja",
  "undo": "Ongedaan maken",
  "upload": "Importeer",
  "validation.between": "Voer een waarde in tussen {min} en {max}",
  "validation.email": "Gelieve een correct email adres in te voeren",
  "validation.invalidDate": "Gelieve een correcte datum in te voeren",
  "validation.length": "De waarde moet minimaal {length} karakters lang zijn",
  "validation.max": "Voer een waarde kleiner dan of gelijk aan {max}",
  "validation.min": "Voor een waarde in groter dan of gelijk aan {min}",
  "validation.required": "Voer een waarde in",
  "year": "{years} jaar",
  "years": "{years} jaar",
  "yes": "Ja",
})
